import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { CallerAddressInput } from '@/models/caller';

export const updateCustomerAddress = async ({ id, data }: { id: number; data: CallerAddressInput }) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
    },
    mutation: graphql(`
      mutation UpdateCallerAddress($id: Float!, $data: CallerAddressInputType!) {
        updateCallerAddress(id: $id, data: $data) {
          id
          name
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          latitude
          longitude
          order
          noteToDriver
          gourmetNoteToDriver
          phoneNumber
          isAirport
          googlePlaceId
          isApproved
        }
      }
    `),
  });

  return response.data?.updateCallerAddress;
};
